export const adminUnitsTypes = {
  HANDLE_ADMIN_UNITS_INPUTS: 'HANDLE_ADMIN_UNITS_INPUTS',
  GET_ADMIN_UNITS: 'GET_ADMIN_UNITS',
  ADD_ADMIN_UNITS: 'ADD_ADMIN_UNITS',
  EDIT_ADMIN_UNIT: 'EDIT_ADMIN_UNIT',
  REMOVE_UNIT: 'REMOVE_UNIT',
  UPDATE_UNIT_INVENTORY: 'UPDATE_UNIT_INVENTORY',
  SET_TRANSFER_BILL: 'SET_TRANSFER_BILL',
  GET_UNIT_CUSTOMERS: "GET_UNIT_CUSTOMERS",
  GET_CREDIT_LIMIT: "GET_CREDIT_LIMIT",
  GET_WHOLESALER_CREDIT_CONDITIONS: "GET_WHOLESALER_CREDIT_CONDITIONS",
  UPDATE_WHOLESALER_CREDIT_CONDITIONS: "UPDATE_WHOLESALER_CREDIT_CONDITIONS",
  RESTORE_INITIAL_STATE: "RESTORE_INITIAL_STATE",
  // Dispensadores (ESTACION)
  GET_UNIT_DISPENSERS: "GET_UNIT_DISPENSERS",
  ADD_UNIT_DISPENSER: "ADD_UNIT_DISPENSER",
  EDIT_UNIT_DISPENSER: "EDIT_UNIT_DISPENSER",
};

export const ADMIN_UNIT_LOADINGS = {
  CREDIT_LIMIT: "creditLimit",
  UPDATE_CREDIT_CONDITIONS: "updateCreditConditions",
  UNIT_CUSTOMERS: "getUnitCustomers",
  GET_CREDIT_CONDITIONS: "getCreditConditions",
  GET_DISPENSERS: "getDispensers",
  SAVE_DISPENSER: "saveDispenser",
  ASSIGN_EQUIPMENT: "assignEquipment",
};
